
import $users from 'stores/users.js'
import $tenants from 'stores/tenants.js'
import $global from 'stores/global'
import {ArrowRight} from '@element-plus/icons-vue'
import UserCompanies from './companies'
import UserTopics from './topics'
import UserContacts from './contacts'
import Tasks from './tasks'
import {API2_USERS} from 'consts/api2'

export default {
  components: {ArrowRight, UserContacts, UserCompanies, UserTopics, Tasks},
  data() {
    return {
      loading: true,
      tenant: undefined,
      user: undefined,
      tabs: [
        {value: 'companies', title: 'User Companies'},
        {value: 'contacts', title: 'User Contacts'},
        {value: 'topics', title: 'User Topics'},
        {value: 'stats', title: 'Stats'},
        {value: 'tasks', title: 'Tasks'},
      ],
      active_tab: 'companies'
    }
  },
  computed: {
    stats_api(){
      if (!this.user?.id) return
      return `${API2_USERS}/${this.user.id}/stats`
    }
  },
  async mounted() {
    this.loading = true
    this.tenant = await $tenants.loadTenant(this.$route.params.id)
    this.user = await $users.loadUser(this.$route.params.user_id)
    this.loading = false
  },
  methods: {
    onGoToTenants() {
      $global.goToTenants()
    },
    onGoToTenant() {
      $global.goToTenant(this.tenant.id)
    }
  }
}
